import { DollarSignIcon, InfoPanelType } from '@grays-npm/component-library';
import type { AuctionState } from '../types/AuctionState';

/**
 * Provides required icon for displaying inside listing notification panel, depending on auction state and notification type.
 */
export function getStatusIcon({
  state,
  type = 'info',
}: {
  state: AuctionState;
  type?: InfoPanelType;
}) {
  if (state === 'sold' && type === 'success') {
    return DollarSignIcon;
  }
  return undefined;
}
